<template>
  <el-dialog title="消息通知" :visible.sync="dialogVisible" width="600px"
    class="notification-dialog" :close-on-click-modal="false" @close="handleClose">

    <div class="notification-content" v-loading="loading">
      <div class="notification-header">
        <div class="notification-title">{{ notificationData.title }}</div>
        <div class="notification-meta">
          <span class="publisher">{{ notificationData.publisher }}发布</span>
          <span class="publish-time">发布时间：{{ notificationData.createTime }}</span>
        </div>
      </div>

      <div class="notification-body">
        <div v-html="notificationData.content" class="notification-content-text"></div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getMessageList, getMessage } from '@/api/index'

export default {
  name: 'NotificationDialog',
  data () {
    return {
      dialogVisible: false,
      loading: false,
      notificationId: '',
      notificationData: {
        title: '',
        publisher: '',
        createTime: '',
        content: ''
      }
    }
  },
  methods: {
    // 打开弹窗
    open () {
      this.loadMessage()
    },
    // 打开指定消息
    openWithMessage (messageData) {
      this.notificationData = messageData
      this.dialogVisible = true
    },
    // 查询消息列表
    loadMessage () {
      getMessageList({
        pageNo: 1,
        pageSize: 1
      }).then(res => {
        const messageList = res.data.list
        if (messageList.length > 0) {
          this.notificationData = messageList[0]
          this.dialogVisible = true
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 关闭弹窗
    handleClose () {
      this.dialogVisible = false
      this.resetData()
      this.$emit('close')
    },

    // 重置数据
    resetData () {
      this.notificationData = {
        title: '',
        publisher: '',
        createTime: '',
        content: ''
      }
      this.notificationId = ''
    },

    // 加载通知数据
    loadNotificationData () {
      this.loading = true
      getMessage({ id: this.notificationId })
        .then(res => {
          this.notificationData = res.data
        })
        .catch(err => {
          this.$message.error(err.message || '加载消息失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.notification-dialog {
  .notification-content {
    padding: 0;
  }

  .notification-header {
    padding-bottom: 15px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 20px;

    .notification-title {
      font-size: 18px;
      font-weight: 500;
      color: #303133;
      margin-bottom: 10px;
      line-height: 1.4;
    }

    .notification-meta {
      font-size: 14px;
      color: #909399;
      display: flex;
      gap: 15px;
      align-items: center;

      .publisher {
        color: #409eff;
      }

      .publish-time {
        color: #c0c4cc;
      }
    }
  }

  .notification-body {
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;

    .notification-content-text {
      font-size: 14px;
      line-height: 1.8;
      color: #606266;
      white-space: pre-wrap;  // 全局保留空格和换行
      word-wrap: break-word;  // 长单词换行

      // 处理v-html内容的样式 - 保留原始格式
      ::v-deep p {
        margin: 0 0 10px 0;
        white-space: pre-wrap !important;  // 保留空格和换行，使用important确保生效
        word-wrap: break-word;  // 长单词换行
        text-indent: 0;  // 重置缩进
        padding-left: 0;  // 重置内边距

        &:last-child {
          margin-bottom: 0;
        }
      }

      // 处理所有文本元素的空格保留
      ::v-deep div,
      ::v-deep span,
      ::v-deep h1,
      ::v-deep h2,
      ::v-deep h3,
      ::v-deep h4,
      ::v-deep h5,
      ::v-deep h6 {
        white-space: pre-wrap !important;
      }

      ::v-deep img {
        max-width: 100%;
        height: auto;
        margin: 10px 0;
      }

      ::v-deep ul,
      ::v-deep ol {
        margin: 10px 0;
        padding-left: 20px;
      }

      ::v-deep li {
        margin: 5px 0;
      }
    }
  }

  .dialog-footer {
    text-align: center;
    padding-top: 20px;
  }
}

// 自定义滚动条样式
.notification-body::-webkit-scrollbar {
  width: 6px;
}

.notification-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.notification-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;

  &:hover {
    background: #a8a8a8;
  }
}
</style>
